import React from 'react';

import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    btn: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
};

class AnnotateLike extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            status: 'annotate',
        };

        this.handleAnnotate = this.handleAnnotate.bind(this);
    }

    handleAnnotate() {
        let { status } = this.state;

        if (status === 'annotate') {
            status = 'gazetter';
        } else if (status === 'gazetter') {
            status = 'annotate';
        }

        this.setState({
            status,
        }, () => {
            this.props.changeTypeAnnotations(status);
        });
    }

    render() {
        const { status } = this.state;

        return (
            <div className='btn'>
                <RaisedButton
                    labelStyle={styles.btn.labelStyle}
                    style={styles.btn.style}
                    buttonStyle={styles.btn.buttonStyle}
                    label={status}
                    onClick={this.handleAnnotate}
                    primary
                />
            </div>
        );
    }
}

export default AnnotateLike;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Management/AnnotateLike.jsx